import { render } from "./pantallas_g.vue?vue&type=template&id=725ad131"
import script from "./pantallas_g.vue?vue&type=script&lang=js"
export * from "./pantallas_g.vue?vue&type=script&lang=js"

import "./pantallas_g.vue?vue&type=style&index=0&id=725ad131&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__